import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import CustomModel, { customModalStyle } from "@NA/Components/ADICustomModal";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import React, { ChangeEventHandler, useEffect, useState } from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { generateAuthorizationMail, setCreditCard, validateCardToken } from "@NA/Services/SavedCreditCardsService";
import translate from "@insite/client-framework/Translate";
import ADICreditCardView from "./ADICreditCardView";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import styled, { ThemeProps, css, withTheme } from "styled-components";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { SettingsCollectionModel } from "@NA/Services/SettingsService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { withProductContext } from "@insite/client-framework/Components/ProductContext";
import { connect, ResolveThunks } from "react-redux";
import Typography from "@insite/mobius/Typography";
import { AnyAaaaRecord } from "dns";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADINewCreditCardModal from "@NA/Components/SaveCard/ADINewCreditCardModal";
import siteMessage from "@insite/client-framework/SiteMessage";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import ValidationSuccessIcon from "@NA/Icons/ValidationSuccessIcon";
import ADIColors from "@NA/Utils/ADIColors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
export interface EPABase {
    ErrorMessage: string;
    ErrorCode: string;
}

export interface EPAValidationRequest extends EPABase {}

export interface EPAValidationResult extends EPABase {}

export interface ADINewCreditCardModalPopupStyle {
    radioListGroup?: RadioGroupProps;
    radioListWrapper?: GridContainerProps;
    radioListLinksGridItem?: GridItemProps;
    rightLinks?: LinkPresentationProps;
    sectionBorder?: InjectableCss;
    savecardContainer?: InjectableCss;
    continueButton?: ButtonPresentationProps;
    newccTremsContainer?: InjectableCss;
    newccTremsText?: InjectableCss;
    newListContainer?: InjectableCss;
    successMessage?: InjectableCss;
    okButton?: InjectableCss;
    centeringWrapper?: InjectableCss;
    loadingSpinner?: LoadingSpinnerProps;
}

export const adiNewCreditCardModalPopupStyle: ADINewCreditCardModalPopupStyle = {
    radioListWrapper: {
        offsetCss: css`
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
            margin: auto;
            ${GridItemStyle} {
                padding-left: 0;
                padding-right: 0;
            }
        `,
        css: css`
            display: "flex";
            align-items: center;
        `,
    },
    radioListGroup: {
        css: css`
            display: "flex";
            align-items: center;
        `,
    },
    radioListLinksGridItem: {
        css: css`
            justify-content: end;
        `,
    },
    rightLinks: {
        css: css`
            padding: 0 8px 0 0;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-weight: bold;
            cursor: pointer;
            :hover {
                text-decoration: underline ${getColor("primary")};
            }
        `,
    },
    sectionBorder: {
        css: css`
            width: 100%;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },

    savecardContainer: {
        css: css`
            display: flex;
            gap: 15px;
            position: relative !important;
            left: 20px !important;
        `,
    },

    continueButton: {
        css: css`
            border-radius: 4px;
            width: 160px;
        `,
    },
    newListContainer: {
        css: css`
            max-width: 355px !important;
            > ${GridOffset} {
                margin-top: 15px;
                > ${GridItemStyle} {
                    display: flex;
                    flex-direction: column;
                    padding-top: 0px;
                    padding-bottom: 0px;
                    margin-bottom: 1rem;
                    > ${TypographyStyle} {
                        margin-bottom: 2px;
                    }
                }
            }
        `,
    },
    successMessage: {
        css: css`
            display: inline-flex;
            width: 100%;
            height: 54px;
            margin: 0px 12px 16px 0px;
            font-size: 14px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.29;
            letter-spacing: normal;
            color: ${ADIColors.black};
        `,
    },
    okButton: {
        css: css`
            border-radius: 4px;
            width: 100%;
            margin-bottom: 15px;
        `,
    },
    newccTremsContainer: {
        css: css`
            margin-top: 15px !important;
            margin-bottom: 32px !important;
        `,
    },
    newccTremsText: {
        css: css`
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            text-align: left;
            color: #2d2926;
            margin: 0px !important;
            > strong {
                font-weight: bold;
            }
        `,
    },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        `,
    },
};

customModalStyle.modalStyle = {
    closeButtonProps: {
        css: css`
            padding: 0;
            &:hover {
                background: transparent;
                border-color: transparent;
            }
            > ${IconWrapper} {
                color: ${getColor("primary")};
                width: 35px;
                height: 35px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                left: 5px;
                            `,
                        ],
                        "max",
                    );
                }}
                > svg {
                    width: 35px;
                    height: 35px;
                    stroke-width: 1.3px;
                }
            }
        `,
    },
    cssOverrides: {
        modalContainer: css`
            div[class^="ContentBody"] {
                max-height: 90vh;
                min-height: 350px;
                max-width: 526px;
                overflow: hidden;
                height: auto;
                padding-bottom: 32px;
                overflow-y: auto;
                max-height: calc(72vh - 28px);
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                max-width: 356px;
                                padding-bottom: 24px;
                            `,
                        ],
                        "max",
                    );
                }}
            }
        `,
        modalBody: css`
            border-radius: 6px;
        `,
        modalContent: css`
            padding: 0px 28px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0px 20px;
                        `,
                    ],
                    "max",
                );
            }}
            > ${GridItemStyle} {
                margin: 0px !important;
                padding: 0 0 22px;
            }
            > div {
                left: 0 !important;
            }
            button {
                max-width: 100%;
                width: 100%;
            }
        `,

        modalTitle: css`
            border-bottom: unset;
            padding: 32px 28px 18px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 24px 20px 18px;
                        `,
                    ],
                    "max",
                );
            }}
            > ${TypographyStyle} {
                font-size: 28px;
                font-weight: bold !important;
                text-align: left;
            }
        `,
    },
};

interface OwnProps {
    setFormError: Function;
    setIsFromError: Function;
    initialNewCardErrorState: InitialCardInterface;
    getApi: Function;
    setIsApiError: Function;
    isNewCardOpen: boolean;
    isFormError: boolean;
    isApiError: boolean;
    formError: InitialCardInterface;
    cardTypes: { key: string; value: string }[] | null | undefined;
    expirationMonths: { key: string; value: number }[] | null | undefined;
    expirationYears: { key: number; value: number }[] | null | undefined;
    paginationModal: any;
    handleNewCardDetails: Function;
    paymentTypes: any;
    showSuccessCallback: Function;
    showErrorCallback: Function;
    closeNewCard: Function;
    userName: string;
    //handleNewCreditCard:Function
}

const styles = adiNewCreditCardModalPopupStyle;

// export interface EpaSettingsCollectionModel extends SettingsCollectionModel {

//     epaSettingSettings : any;
// }
const SuccessMessage = styled.div`
    padding: 2px;
    display: flex;
    margin: 5px 0 7px;
    gap: 15px;
    margin-bottom: 15px;
    margin-top: 15px;
    align-items: flex-start;
`;
const mapStateToProps = (state: CustomApplicationState) => {
    const cart = getCurrentCartState(state);
    const billToState = getBillToState(state, cart?.value?.billToId);
    const catalogRootPath = state.context.settings.settingsCollection;
    const currentPage = getCurrentPage(state).type;
    const isCheckout = currentPage === "CheckoutReviewAndSubmitPage";
    return {
        session: state.context.session,
        firstName: state.context.session.firstName,
        lastName: state.context.session.lastName,
        userName: state.context.session.userName,
        billToState,
        creditCardPaymentTypes: state.ADIGlobalData.adiCreditCardListRecapStore.creditCardDetails,
        catalogRootPath,
        isCheckout,
    };
};

interface InitialCardInterface {
    selectedCardType: boolean;
    creditCardNumber: boolean;
    expMonth: boolean;
    expYear: boolean;
    securityCode: boolean;
    zipCode: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CenteringWrapper = styled.div<InjectableCss>`
    ${({ css }) => css}
`;

const ADINewCreditCardModalPopup = ({
    showSuccessCallback,
    showErrorCallback,
    closeNewCard,
    isNewCardOpen,
    paymentTypes,
    setFormError,
    setIsFromError,
    initialNewCardErrorState,
    handleNewCardDetails,
    getApi,
    paginationModal,
    setIsApiError,
    userName,
    firstName,
    lastName,
    billToState,
    creditCardPaymentTypes,
    catalogRootPath,
    isCheckout,
}: Props) => {
    const [selectedCardType, setSelectedCardType] = useState("");
    const [creditCardNumber, setCreditCardNumber] = useState("");
    const [expYear, setExpYear] = useState("");
    const [expMonth, setExpMonth] = useState("");
    const [securityCode, setSecurityCode] = useState("");
    const [zipCode, setZipCode] = useState("");
    //const [source, setSource] = useState("reviewandpay");
    const [postalCodeRegEx, setPostalCodeRegEx] = useState("");
    // const [postalCodeLength, setPostalCodeLength] = useState<number>(5);
    const [cardLength, setCardLength] = useState<number>(16);
    const [securityCodeLength, setSecurityCodeLength] = useState<number>(3);
    const [isLoading, setIsLoading] = useState(false);
    // const [isApiErrorMessage, setIsApiErrorMessage] = useState("");
    // const [country, setCountry] = useState<CountryModel | null>(null)
    const [CardResult] = useState(paymentTypes);
    const [CCPaymentTypes] = useState<any>(creditCardPaymentTypes);
    const [successCount, setSuccessCount] = useState(false);
    const [isSucessModalOpen, setIsSucessModalOpen] = useState(false);
    const [showNewCreditCard, setshowNewCreditCard] = useState<boolean>(false);
    // to initialize the epicore moethods

    useEffect(() => {
        settingsSuccessHandler();
    }, [successCount]);

    const closeSuccessModal = () => {
        setIsSucessModalOpen(false);
    };
    // Method to open New Credit card Epicore Modal popup

    const openNewcardPopup = () => {
        closeLTLModal();
        setSuccessCount(!successCount);

        showModal(
            () => {},
            () => {},
        );
    };

    const showModal = (successCallback_fn: Function, errorCallback_fn: Function) => {
        setIsLoading(true);

        (async () => {
            while (!window.hasOwnProperty("HostedPayment")) {
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            const hostedPayment = window["HostedPayment" as keyof typeof window];

            showSuccessCallback = successCallback_fn;
            showErrorCallback = errorCallback_fn;

            hostedPayment.open({
                public_key: "pk_0Zq6VpALF3Q7Fp5tW8LyiTZzasAIq2d6",
                namespace: "160386",
                name: translate("New Credit Card"),
                button: translate("Save Card"),
                cancel_button: translate("Cancel"),
                lang: "en_US",
                style_config: {
                    body_background: "#fff",
                    header_border: "1px solid #000",
                    control_font: "verdana",
                    control_font_size: "12px",
                    control_font_color: "#666",
                    control_background: "#fff",
                    btn_font: "verdana",
                    btn_font_size: "18px",
                    btn_font_color: "#fff",
                    btn_font_background: "#004da6",
                },
                translation_config: {
                    ccnum_lbl: "Card Number",
                    ccnum_plh: "Enter card number",
                    expiry_lbl: "Expiration Date",
                    expiry_plh: "MMYY",
                    cvv_lbl: "Security Code*",
                    cvv_phl: "CVV",
                    expiry_err1: "Expiration Date Required",
                    ccnum_err: "Please specify a valid credit card number.",
                    cvv_err: "Invalid CVV/CVC.",
                    branding_text: "By Selecting this Card I am accepting the ADI Credit Card Terms & Conditions",
                },
            });

            await waitForIframe();
            setIsLoading(false);
        })();
    };

    // Wait for iframe to become visible
    const waitForIframe = async () => {
        while (!$('iframe[name="hosted_payments_app"]').is(":visible")) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }
    };

    const closeLTLModal = () => {
        closeNewCard();
    };

    const validationSuccessHandler = (result: EPAValidationResult, callback?: () => void) => {
        if (typeof callback === "function") {
            callback();
        }
    };

    const validationFailureHandler = (callback?: () => void) => {
        if (typeof callback === "function") {
            callback();
        }
    };

    const setupFailureHandler = async (response: any, ecb: Function) => {
        const url = "/api/v3/epa" + "/validate";
        // that.debug('HostedPayment Setup Error: ' + response.error);
        const res = await validateCardToken(response);
        if (res.ReturnCode == "00") {
            validationSuccessHandler(res);
        } else {
            var errData = {
                code: res.status,
                message: "Error Adding Card", //data.statusText
            };
            validationFailureHandler();
        }
    };

    // const validateCardToken1 = (url: string, request: EPAValidationRequest,successCallback?: () => void, errorCallback ?: () => void) => {

    //   $.ajax({
    //             url: url,
    //             type: "POST",
    //             //crossDomain: true,
    //             data: request,
    //             dataType: "json",
    //             success: function (result) {
    //                 if (result.ReturnCode == "00") {
    //                     validationSuccessHandler(result, successCallback);

    //                 } else {
    //                     var errData = {
    //                         code: result.status,
    //                         message: "Error Adding Card" //data.statusText
    //                     };
    //                     validationFailureHandler(errorCallback);
    //                 }
    //             },
    //             error: function (data) { //xhr, status, error) {

    //                 var errData = {
    //                     code: data.status,
    //                     message: "Error Adding Card" //data.statusText
    //                 };
    //                 validationFailureHandler(errorCallback); //result
    //             }
    //         });
    //     }

    const createAuthorizationMail = async (creditcard: any, cardTypeDesc: string) => {
        var creditCardPopupDetail: any = {
            creditCardData: [],
            uri: "/api/v2/creditcardpopupdetails",
            properties: {},
        };

        if (creditcard.ccType == "AX") {
            cardTypeDesc = "Amex";
        } else if (creditcard.ccType == "VI") {
            cardTypeDesc = "Visa/Master";
        } else if (creditcard.ccType == "MC") {
            cardTypeDesc = "Visa/Master";
        } else if (creditcard.ccType == "DS") {
            cardTypeDesc = "Discover";
        }

        let customerSuffix = "";
        let customerNbr = "";
        let customerNumber = billToState?.value?.customerNumber;
        if (customerNumber) {
            customerSuffix = customerNumber.substring(customerNumber.lastIndexOf("-") + 1);
            // customerNbr = customerNumber.substring(0, 6);
            // change for new P21 Prod CC fix
            customerNbr = customerNumber.split("-", 1).toString();
        }

        creditCardPopupDetail.creditCardData.push({
            customerNbr: customerNbr,
            customerSuffix: customerSuffix,
            customerName: billToState?.value?.customerName,
            webUserFirstName: firstName,
            webUserLastName: lastName,
            userName: userName,
            webUserEmail: userName,
            tokenCC: creditcard.ccToken,
            cardLastCC: creditcard.ccNumber,
            cardTypeCC: creditcard.ccType,
            expiryMonth: creditcard.ccExpiryMonth,
            expiryYear: creditcard.ccExpiryYear,
            optionYN: "Y",
            uri: "/api/v2/creditcardpopupdetails",
            properties: {},
            cardTypeDesc: cardTypeDesc,
        });

        const result = await generateAuthorizationMail(creditCardPopupDetail);
    };

    const setupSuccessHandler = async (response: any, scb: Function, ecb: Function) => {
        setIsLoading(true);
        if (response.success) {
            var p21Pt; // = that.getP21PaymentType(response.cardtype);
            if (CardResult) paymentTypes = CardResult.paymentTypes;
            else paymentTypes = CCPaymentTypes.paymentTypes;
            var description = "";
            switch (response.cardtype.toUpperCase()) {
                case "AX":
                    p21Pt = paymentTypes.find((p: { payment_type_desc: string }) => {
                        return p.payment_type_desc.toUpperCase() == "Amex".toUpperCase();
                    });
                    description = "Amex" + " " + response.masked.substring(response.masked.length - 4);
                    break;
                case "VI":
                    p21Pt = paymentTypes.find((p: { payment_type_desc: string }) => {
                        return p.payment_type_desc.toUpperCase() == "Visa/Master".toUpperCase();
                    });
                    description = "Visa" + " " + response.masked.substring(response.masked.length - 4);
                    break;
                case "MC":
                    p21Pt = paymentTypes.find((p: { payment_type_desc: string }) => {
                        return p.payment_type_desc.toUpperCase() == "Visa/Master".toUpperCase();
                    });
                    description = "Mast" + " " + response.masked.substring(response.masked.length - 4);
                    break;
                case "DS":
                    p21Pt = paymentTypes.find((p: { payment_type_desc: string }) => {
                        return p.payment_type_desc.toUpperCase() == "Discover".toUpperCase();
                    });
                    description = "Disc" + " " + response.masked.substring(response.masked.length - 4);
                    break;
            }

            var newCreditcard: any = {
                ccToken: response.token, //this.cardToken,
                ccExpiryMonth: response.expdate.substr(0, 2), // this.cart.paymentOptions.creditCard.expirationMonth.toString(),
                ccExpiryYear: response.expdate.substr(2, 2), //  this.cart.paymentOptions.creditCard.expirationYear.toString(),
                ccID: response.transid,
                ccNumber: response.masked, // this.paymentTokenService.getCardMask(this.newCreditCardModel.cardType, this.newCreditCardModel.cardNumber),
                ccPostalCode: "", // this.newCreditCardModel.postalCode,
                ccCvc: response.cvv, // this.newCreditCardModel.cardCvc,
                ccType: response.cardtype,
                isDefault: true,
                xiResponse: JSON.stringify(response),
                ccDesc: p21Pt.payment_type_desc,
                properties: {
                    payment_type_id: p21Pt.payment_type_id,
                    payment_method_id: p21Pt.payment_method_id,
                    payment_type_desc: p21Pt.payment_type_desc,
                    cardtype: response.cardtype,
                    lastfour: response.lastfour,
                    masked: response.masked,
                },
                uri: "",
            };
            newCreditcard.properties["provider"] = "Epicore";
            newCreditcard.properties["source"] = "reviewandpay";
            newCreditcard.properties["transid"] = response.transid;
            newCreditcard.properties["expdate"] = response.expdate;
            newCreditcard.properties["cardtype"] = response.cardtype;
            newCreditcard.properties["payment_type_id"] = p21Pt.payment_type_id;
            newCreditcard.properties["payment_method_id"] = p21Pt.payment_method_id;
            newCreditcard.properties["payment_type_desc"] = p21Pt.payment_type_desc;
            newCreditcard.properties["description"] = description;
            newCreditcard.properties["storageLevel"] = CardResult.storageLevel; // (that.storageLevel == 'CU') ?"Customer":(that.storageLevel == 'ST')?"ShipTo":"";

            let result;
            try {
                result = await setCreditCard(newCreditcard);
            } catch (error) {
                newCardSubmitHandler(error);
            }
            newCardSubmitHandler(result);
            createAuthorizationMail(result, p21Pt.payment_type_desc);

            // this.SetCreditCard(newCreditcard).success((cc_card : any) => {
            //     if (cc_card.properties['returnCode'] == '00') {
            //        // _this.$rootScope.$broadcast("CardAdded", cc_card);
            //         scb.call(_this, cc_card);
            //     } else {
            //         var errData = {
            //             code: cc_card.properties['returnCode'],
            //             message: cc_card.properties['returnMsg']
            //         };
            //         ecb.call(_this, errData);
            //     }
            // }).error((data : any) => {
            //     var errData = {
            //         code: data.status,
            //         message: (typeof data.message != undefined) ? data.message : "Adding Card has failed, please try again." //data.statusText
            //     };
            //     ecb.call(_this, errData);
            // });
        } else {
            var errData = {
                code: "99",
                message: "Adding Card has failed, please try again.", //data.statusText
            };
            //  ecb.call(_this, errData);
        }
    };

    const newCardSubmitHandler = async (result: any) => {
        if (result?.ccid) {
            setFormError(initialNewCardErrorState);
            setIsFromError(false);
            setIsSucessModalOpen(true);

            const ccid = result?.ccid;
            handleNewCardDetails(result);
            // closeLTLModal(); fixing invoice page CC bug
            if (ccid) {
                getApi(paginationModal?.numberOfPages, 4, result);
            } else {
                getApi();
            }
        } else {
            setFormError("error");
            setIsFromError(true);
            setIsSucessModalOpen(false);
        }
        setIsLoading(false);
    };

    const settingsSuccessHandler = () => {
        let hostedPayment;
        (async () => {
            while (!window.hasOwnProperty("HostedPayment")) {
                // define the condition as you like

                await new Promise(resolve => {
                    if (!window.hasOwnProperty("HostedPayment")) setTimeout(resolve, 500);
                });

                //hostedPayment = window["HostedPayment" as keyof typeof window];
            }

            let count = false;
            hostedPayment = window["HostedPayment" as keyof typeof window];
            hostedPayment.setup({
                response: function (response: any) {
                    if (response.success && count == false) {
                        count = true;
                        setupSuccessHandler(response, showSuccessCallback, showErrorCallback);
                    } else {
                        // setupFailureHandler(response, showErrorCallback);
                    }
                },
                close_handler: function (response: any) {
                    closeHandler(response);
                },
                // service_uri: "sce.toogo.io" //This should be picked up from settings
                //    service_uri: catalogRootPath?.epaSettingSettings?.service_uri
            });
        })();
    };

    const closeHandler = (response: any, callback?: () => void) => {
        if (typeof callback === "function") {
            callback();
        }
    };

    const IsValidation = (): boolean => {
        setFormError(initialNewCardErrorState);
        setIsFromError(false);
        let isError = false;
        const zipPattern = new RegExp(postalCodeRegEx);
        if (zipCode === "" || !zipPattern.test(zipCode)) {
            setFormError((prev: InitialCardInterface) => ({ ...prev, zipCode: true }));
            setIsFromError(true);
            isError = true;
        }
        if (selectedCardType === "") {
            setFormError((prev: InitialCardInterface) => ({ ...prev, selectedCardType: true }));
            setIsFromError(true);
            isError = true;
        }

        if (creditCardNumber === "" || creditCardNumber.length !== cardLength) {
            setFormError((prev: InitialCardInterface) => ({ ...prev, creditCardNumber: true }));
            setIsFromError(true);
            isError = true;
        }

        if (securityCode === "" || securityCode.length !== securityCodeLength) {
            setFormError((prev: InitialCardInterface) => ({ ...prev, securityCode: true }));
            setIsFromError(true);
            isError = true;
        }
        if (expMonth === "" || checkExpirationDate(parseInt(expMonth).toString(), expYear.toString().substring(2, 4))) {
            setFormError((prev: InitialCardInterface) => ({ ...prev, expMonth: true }));
            setIsFromError(true);
            isError = true;
        }
        if (expYear === "") {
            setFormError((prev: InitialCardInterface) => ({ ...prev, expYear: true }));
            setIsFromError(true);
            isError = true;
        }

        return isError;
    };

    const checkExpirationDate = (month: any, year: any) => {
        var d = new Date();
        month = parseInt(month);
        year = year.length == 2 ? parseInt(d.getFullYear().toString().substring(0, 2) + year) : year;
        if (year == d.getFullYear() && month < d.getMonth() + 1) {
            return true;
        }

        if (year < d.getFullYear()) {
            return true;
        }

        return false;
    };

    return (
        <>
            {isLoading && (
                <CenteringWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.loadingSpinner} />
                </CenteringWrapper>
            )}
            {!isCheckout && (
                <CustomModel
                    headline={"Add a New Card"}
                    isOpen={isSucessModalOpen}
                    handleClose={closeSuccessModal}
                    errorStyle={false}
                >
                    <>
                        <GridContainer {...styles.newListContainer}>
                            <SuccessMessage>
                                <Icon src={ValidationSuccessIcon} />
                                <Typography {...styles.successMessage}>
                                    {translate(
                                        "Your card has been added to this account. You can begin using it for payments immediately.",
                                    )}
                                </Typography>
                            </SuccessMessage>
                            <Button
                                onClick={() => {
                                    closeSuccessModal();
                                }}
                                variant="primary"
                                {...styles.okButton}
                            >
                                {translate("Ok")}
                            </Button>
                        </GridContainer>
                    </>
                </CustomModel>
            )}
            <CustomModel
                headline={"New Credit Card"}
                isOpen={isNewCardOpen}
                handleClose={closeNewCard}
                errorStyle={false}
            >
                <>
                    <GridItem width={12} {...styles.newccTremsContainer}>
                        <Typography {...styles.newccTremsText}>{siteMessage("NewCreditCard_Message")}</Typography>
                    </GridItem>

                    <StyledWrapper {...styles.savecardContainer}>
                        <Button onClick={closeLTLModal} variant="secondary" {...styles.continueButton}>
                            {translate("Cancel")}
                        </Button>
                        <Button onClick={openNewcardPopup} variant="primary" {...styles.continueButton}>
                            {translate("Continue")}
                        </Button>
                    </StyledWrapper>
                </>
            </CustomModel>
        </>
    );
};

//export default withTheme(ADINewCreditCardModalPopup);
export default connect(mapStateToProps)(ADINewCreditCardModalPopup);
